import { AfterViewInit, Component, inject, Input, OnInit } from '@angular/core';
import { BmsAdminService } from '../../services/bms-admin-service';

@Component({
  selector: 'app-bms-customer-string-history',
  templateUrl: './bms-customer-string-history.component.html',
  styleUrls: ['./bms-customer-string-history.component.scss']
})
export class BmsCustomerStringHistoryComponent implements OnInit, AfterViewInit {

  private adminService: BmsAdminService = inject(BmsAdminService);

  @Input() customerId : string;
  @Input() stringId : string;

  stringHistory : {value : string, timestamp : Date}[] = [];

  constructor() { }

  ngOnInit() {

  }

  ngAfterViewInit(): void {
    this.getStringHistory();
  }

  async getStringHistory() {
    if (this.customerId?.length > 0) {
      this.stringHistory = await this.adminService.getCustomerStringHistory(this.customerId, this.stringId);
    }
  }

}
